module.exports = __webpack_public_path__ + "img/upload-img-icon.062040ae.png";